import { useState, useEffect, useCallback } from 'react'
import { useCadaverService } from 'hooks/useCadaverService'

export const useFormTatuagensECicatrizes = ({
  idExameRealizado,
  idCadaver,
  setCicatrizesForm,
  setSVGTatuagensForm,
}) => {
  const [processandoCicatrizes, setProcessandoCicatrizes] = useState(true)
  const [cicatrizes, setCicatrizes] = useState([])
  const cadaverService = useCadaverService()

  const fetchCicatrizes = useCallback(async () => {
    setProcessandoCicatrizes(true)
    if (idExameRealizado && idCadaver) {
      try {
        const response = await cadaverService.listarCicatrizesCadaverAsync(idExameRealizado, idCadaver)
        if (response) {
          const ordenadas = [...response].sort((a, b) => (a.id || 0) - (b.id || 0))
          setCicatrizes(ordenadas)
        }
      } catch (error) {
        console.error('Error fetching cicatrizes:', error)
      }
    }
    setProcessandoCicatrizes(false)
  }, [idCadaver, idExameRealizado]) // Excluded cadaverService to prevent infinite loop

  useEffect(() => {
    fetchCicatrizes()
  }, [fetchCicatrizes])

  useEffect(() => {
    if (setCicatrizesForm) {
      setCicatrizesForm(cicatrizes.map((c) => c))
    }
  }, [cicatrizes, setCicatrizesForm])

  const setSVGElements = useCallback((newValue) => {
    if (setSVGTatuagensForm) {
      setSVGTatuagensForm((prevState) => ({
        ...prevState,
        svgFront: newValue.svgFront,
        svgLeft: newValue.svgLeft,
        svgRight: newValue.svgRight,
        svgBack: newValue.svgBack,
      }))
    }
  }, [setSVGTatuagensForm])

  return {
    processandoCicatrizes,
    cicatrizes,
    setCicatrizes,
    setSVGElements,
  }
}
